// Drag-to-Dismiss für Sheet-Overlays (per Griff nach unten ziehen zum Schließen) - geteiltes
// Composable statt in jedem der 4 Overlay-Components (DetailOverlay, StandingsOverlay,
// RanglisteOverlay, MenueOverlay) dieselbe Logik zu duplizieren.
//
// Verwendung in einer Overlay-Komponente:
//
//   <template>
//     <div class="tm-detail-overlay" :style="dragStyle"
//          @pointermove="ziehenBewegen" @pointerup="ziehenEnde" @pointercancel="ziehenEnde">
//       <div class="tm-sheet-griff" @pointerdown="ziehenStart"></div>
//       ...
//     </div>
//   </template>
//
//   <script setup>
//   import { useSheetDrag } from '../composables/useSheetDrag.js'
//   const emit = defineEmits(['close'])
//   const { ziehenStart, ziehenBewegen, ziehenEnde, dragStyle } = useSheetDrag(() => emit('close'))
//   </script>

import { ref, computed, onMounted, onUnmounted } from 'vue'

// Globaler, geteilter Zähler "wie viele Sheets sind gerade offen (gemountet)" - auf window
// statt einer Modul-Variable, damit ihn auch normales (nicht-Vue-)JavaScript lesen kann, z.B.
// das Pull-to-Refresh-Skript. Zähler statt Boolean, falls (auch nur kurzzeitig beim Wechsel)
// mehrere Sheets gleichzeitig offen sein könnten.
if (typeof window !== 'undefined' && window.__tmOffeneSheets == null) {
  window.__tmOffeneSheets = 0
}

export function useSheetDrag(schliessenCallback, schwelleInPx = 120) {
  const sheetDragY = ref(0)
  const sheetAmZiehen = ref(false)
  let dragStartY = 0

  // Sheet zählt sich selbst mit, sobald es gemountet wird (v-if wird true) - und wieder ab,
  // sobald es entfernt wird (v-if wird false). Kein Zutun der einzelnen Widgets nötig.
  onMounted(() => {
    if (typeof window !== 'undefined') window.__tmOffeneSheets++
  })
  onUnmounted(() => {
    if (typeof window !== 'undefined') window.__tmOffeneSheets = Math.max(0, window.__tmOffeneSheets - 1)
  })

  function ziehenStart(e) {
    dragStartY = e.clientY
    sheetAmZiehen.value = true
    e.currentTarget?.setPointerCapture?.(e.pointerId)
  }

  function ziehenBewegen(e) {
    if (!sheetAmZiehen.value) return
    sheetDragY.value = Math.max(0, e.clientY - dragStartY)
  }

  function ziehenEnde() {
    if (!sheetAmZiehen.value) return
    sheetAmZiehen.value = false
    if (sheetDragY.value > schwelleInPx) {  
      schliessenCallback()
    }
    sheetDragY.value = 0
  }

  // Beim aktiven Ziehen keine Transition (folgt 1:1 dem Finger/der Maus ohne Verzögerung),
  // beim Loslassen (egal ob schließt oder zurückschnappt) sanft animiert statt abrupt zu springen.
  const dragStyle = computed(() => ({
    transform: sheetDragY.value > 0 ? `translateY(${sheetDragY.value}px)` : undefined,
    transition: sheetAmZiehen.value ? 'none' : 'transform 0.2s ease'
  }))

  return { ziehenStart, ziehenBewegen, ziehenEnde, dragStyle }
}